module.exports = __webpack_public_path__ + "static/media/event-accent.5f7b57a5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/event-accent.svg
// module id = 196
// module chunks = 0